import styled from 'styled-components';

export interface ScSliderProps {
  slidesPerView?: number;
}

export const ScSlider = styled.div<ScSliderProps>`
  position: relative;
  overflow-x: scroll;
  display: flex;
  gap: 16px;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }

  .snap-item {
    flex: ${({ slidesPerView }) =>
      `0 0 ${slidesPerView ? (100 * 100) / (slidesPerView * 100) : 100}%`};
    scroll-snap-align: start;
  }
`;
